import React from 'react';
import { DropdownButton } from 'react-bootstrap';
import { camelizeKeys } from 'humps';
import { EditParentPortfolioLink } from '../links/index.jsx';
import { EditBlueIcon } from '../icons/EditBlueIcon.jsx';
import { DeleteBlueIcon } from '../icons/DeleteBlueIcon.jsx';
import CustomMenuItem from '../CustomMenuItem.jsx';

const ParentPortfoliosActionDropdown = ({
  parentPortfolioId,
  onDeleteParentPortfolio,
  parentPortfolio,
}) => {
  const { canManage, canDelete } = camelizeKeys(parentPortfolio.permissions);
  return (
    <div className="actions">
      <DropdownButton
        noCaret
        title=""
        id="parent-portfolio-action-dropdown"
        className="btn-more btn btn-default"
      >
        {canManage ? (
          <React.Fragment>
            <EditParentPortfolioLink parentPortfolioId={parentPortfolioId}>
              <CustomMenuItem>
                <span className="flex">
                  <EditBlueIcon />
                  <span>&nbsp; Edit</span>
                </span>
              </CustomMenuItem>
              <CustomMenuItem divider />
            </EditParentPortfolioLink>
          </React.Fragment>
        ) : null}

        {canDelete ? (
          <span className="item">
            <CustomMenuItem
              onClick={() => onDeleteParentPortfolio(parentPortfolioId)}
            >
              <span className="flex">
                <DeleteBlueIcon />
                <span>&nbsp; Delete</span>
              </span>
            </CustomMenuItem>
            <CustomMenuItem divider />
          </span>
        ) : null}
      </DropdownButton>
    </div>
  );
};

export default ParentPortfoliosActionDropdown;
